<template>
  <vs-row vs-justify="center">
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Website" v-model="link.web" @change="updateSocial" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Facebook" v-model="link.fb" @change="updateSocial" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Google" v-model="link.google" @change="updateSocial" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Youtube" v-model="link.youtube" @change="updateSocial" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input label="Instagram" v-model="link.insta" @change="updateSocial" />
    </vs-col>
    <vs-col vs-lg="6" vs-xs="12">
      <vs-input
        label="linkedIn"
        v-model="link.linkedIn"
        @change="updateSocial"
      />
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: "SocialLinks",
  data: () => ({
    link: {
      web: "",
      fb: "",
      google: "",
      youtube: "",
      insta: "",
      linkedIn: "",
    },
  }),
  methods: {
    updateSocial() {
      this.$emit("input", this.$data.link);
    },
  },
  created() {
    this.$events.on("reset", () => {
      this.$data.link = {
        web: "",
        fb: "",
        google: "",
        youtube: "",
        insta: "",
        linkedIn: "",
      };
    });
  },
};
</script>
